import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Trash2,
  Plus,
  Minus,
  ShoppingCart,
  Package,
  CreditCard,
  Truck,
  CheckCircle,
  Timer,
  Shield,
  Zap,
  Eye,
  MapPin,
  Pencil,
  Check,
  X,
  Calendar,
  Percent,
  Copy,
} from "lucide-react";
import OurLayouts from "./layout/index";
import axios from "axios";
import Labimg from "../assets/labtest_icon.svg";
import PaymentModeModal from "./PatientRegister/PaymentModeModal";
import { toast } from "react-toastify";
import moment from "moment";
import PreferedDateAndTime from "./PreferedDateAndTime";
import ConsentModal from "./Consent/ConsentModal";
import { ClimbingBoxLoader } from "react-spinners";
import { getHospitalDetails } from "../utils/hospitalStorage";
const CART_SECTION_HEADER_GRADIENT =
  "linear-gradient(90deg, #D4EDE9 0%, #FFFFFF 100%)";

const PATIENT_STRIP_GRADIENT =
  "linear-gradient(90deg, #D4EDE9 0%, #FFFFFF 100%)";

const CART_CARD_STYLE = {
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
};

const AVAILABLE_LAB_COUPONS = [
  {
    code: "CB_LAB10",
    description: "Flat 10% discount on lab tests",
  },
];

export default function LabCartPage() {
  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const [medicines, setMedicines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cartId, setCartId] = useState(null);
  const [removingItems, setRemovingItems] = useState(new Set());
  const [updatingQuantity, setUpdatingQuantity] = useState(new Set());
  const patientId = location.state?.patientId;
  const selectedPatient = location.state?.selectedPatient;
  const [cartList, setCartList] = useState([]);
  const [labCartDetails, setLabCartDetails] = useState(null);
  const [labtests, setlabtests] = useState([]);
  const [labTestBill, setLabTestBill] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [medicineBill, setMedicineBill] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [orderid, setorderid] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [medicineDetails, setMedicineDetails] = useState();
  const [preferDate, setPreferDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [patientDetails, setPatientDetails] = useState({});
  const [preferModalOpen, setPreferModalOpen] = useState(false);
  const [addressModalOpen, setaddressModalOpen] = useState(false);
  const [preferTime, setPreferTime] = useState("");
  const [addressOption, setAddressOption] = useState("clinic");
  const [preferDateupdate, setPreferDateupdate] = useState("");
  const [patientAddresses, setPatientAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [editAddressModalOpen, setEditAddressModalOpen] = useState(false);
  const [addressToEdit, setAddressToEdit] = useState(null);
  
  // Edit form state
  const [editHouseNo, setEditHouseNo] = useState("");
  const [editAddress1, setEditAddress1] = useState("");
  const [editPincode, setEditPincode] = useState("");
  const [editFetchedState, setEditFetchedState] = useState("");
  const [editFetchedCountry, setEditFetchedCountry] = useState("India");
  const [editErrors, setEditErrors] = useState({});

  const [consentModalOpen, setConsentModalOpen] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false);
  const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [couponInput, setCouponInput] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState("");
  const [applyingCoupon, setApplyingCoupon] = useState(false);
  const [removingCoupon, setRemovingCoupon] = useState(false);

  const [addressupdate, setAddressupdate] = useState("");
  const [clinicaddress, setClinicaddress] = useState("");
  const [patientaddress, setPatientaddress] = useState("");
  const changeDate = (date) => {
    setPreferDate(moment(date, "DD-MM-YYYY").format("YYYY-MM-DD"));

    date = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss");
  };

  // Function to fetch address details by pincode
  const fetchAddressByPincode = async (pincode) => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      
      const response = await axios.get(
        `${process.env.REACT_APP_NEWBASEURL}getAllAddressDetails/list?pincode=${pincode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      
      console.log("Address API response:", response.data.data);
      
      if (response.data.data && response.data.data.length > 0) {
        const addressData = response.data.data[0]; // Take first entry since all have same state/district
        
        // Create area options for dropdown
        const areas = response.data.data.map(item => ({
          value: item.area,
          label: item.area,
          key: item.area
        }));
        setAreaOptions(areas);
        
        // Update state variables
        setFetchedState(addressData.state || "");
        setFetchedCity(addressData.area || ""); // Using area as city
        setFetchedCountry("India");
        
        // Update form fields
        setStateField(addressData.state || "");
        setCity(addressData.area || "");
        
        console.log("Address fields updated:", {
          state: addressData.state,
          city: addressData.area,
          country: "India"
        });
      }
    } catch (error) {
      console.error("Error fetching address details:", error);
      toast.error("Failed to fetch address details");
    }
  };
  const [houseNo, setHouseNo] = useState("");
  const [address1, setAddress1] = useState("");
  const [landmark, setLandmark] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [stateField, setStateField] = useState("");
  const [fetchedState, setFetchedState] = useState("");
  const [fetchedCity, setFetchedCity] = useState("");
  const [fetchedCountry, setFetchedCountry] = useState("");
  const [areaOptions, setAreaOptions] = useState([]);

  // Function to reset address form fields
  const resetAddressForm = () => {
    setHouseNo("");
    setAddress1("");
    setPincode("");
    setCity("");
    setFetchedState("");
    setFetchedCountry("");
    setStateField("");
  };

  const [deliveryaddress, setDeliveryaddress] = useState({
    address1: "",
    deliveryCity: "",
    deliveryState: "",
    deliveryCountry: "",
    deliveryPinCode: "",
  });
  const [prefereeddate, setPrefereeddate] = useState({
    date: "",
    time: "",
  });
  const hospitaldata = getHospitalDetails();
  console.log(hospitaldata, "hospitalghvj");
    useEffect(() => {
      if (hospitaldata ) {
        setDeliveryaddress({
          address1: hospitaldata?.address, // or whatever you want
          deliveryCity: hospitaldata.city,
          deliveryState: hospitaldata.state,
          deliveryCountry: hospitaldata.country,
          deliveryPinCode: hospitaldata.pinCode,
        });
      }
    }, []);
  const handleChange = (e) => {
    let value = e?.target?.value;
    let time = convertTime(value.substring(0, 5));
    setPreferTime(value ? value : "");

    localStorage.setItem("preferTime", JSON.stringify(time));
    localStorage.setItem("preferValue", JSON.stringify(value));
    localStorage.setItem("preferDate", JSON.stringify(preferDate));
  };
  const convertTime = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours] = time.split(":");
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}`;
  };
  const fetchCartList = async () => {
    if (!patientDetails.curebayPatientId) return;
    const token = localStorage.getItem("auth_token");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_CARTURL}common/cart-list/${patientDetails.curebayPatientId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCartList(data.data.carts || []);
    } catch (err) {
      console.error("Failed to fetch cart list:", err.response?.data || err);
    }
  };

  // Fetch address details by pincode for edit form
  const fetchEditAddressByPincode = async (pincode) => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      
      const response = await axios.get(
        `${process.env.REACT_APP_NEWBASEURL}getAllAddressDetails/list?pincode=${pincode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      
      console.log("Edit Address API response:", response.data.data);
      
      if (response.data.data && response.data.data.length > 0) {
        const addressData = response.data.data[0];
        
        // Update edit form state variables
        setEditFetchedState(addressData.state || "");
        setEditFetchedCountry("India");
        
        console.log("Edit Address fields updated:", {
          state: addressData.state,
          country: "India"
        });
      }
    } catch (error) {
      console.error("Error fetching edit address details:", error);
      toast.error("Failed to fetch address details");
    }
  };

  // Handle edit address form submission
  const handleEditAddressSubmit = async () => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");

      const payload = {
        address: editHouseNo,
        landmark: editAddress1,
        state: editFetchedState,
        pincode: editPincode,
        country: editFetchedCountry,
        patientId: patientId,
      };

      const response = await fetch(
        `${API_URL}addressbook/${addressToEdit.id}`,
        {
          method: "PUT",
          headers: { 
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, 
              tenantId: tenantId 
            },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`);
      }

      const responseData = await response.json();
      
      if (responseData && responseData.id) {
        // toast.success("Address updated successfully!");
        
        // Update the address in the list
        setPatientAddresses(prev => 
          prev.map(addr => 
            addr.id === responseData.id ? responseData : addr
          )
        );
        
        // Update selected address if it was the one being edited
        if (selectedAddress?.id === addressToEdit.id) {
          setSelectedAddress(responseData);
        }
        
        setEditAddressModalOpen(false);
        setAddressToEdit(null);
      } else {
        toast.error("Address update failed - unexpected response");
      }
    } catch (error) {
      console.error("Edit address error:", error);
      toast.error(error.message || "Failed to update address");
    }
  };

  useEffect(() => {
    fetchCartList();
  }, [patientDetails.curebayPatientId]);
  const fetchpatient = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");

    try {
      const response = await axios.get(
        `${API_URL}patient/search?patientId=${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      console.log(response.data, "zsxdcfvghbjcfvgbh");
      const firstPatient = response?.data.data[0];
      console.log(firstPatient, "dfghjk");
      setPatientDetails(firstPatient);
    } catch (error) {
      console.error("Error fetching slots:", error);
    }
  };
  useEffect(() => {
    fetchpatientaddress()
    fetchpatient();
  }, [patientId]);

  // Fetch patient addresses
  const fetchpatientaddress = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    try {
      const response = await axios.get(
        `${API_URL}addressbook/getBy?patientId=${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      console.log(response.data, "patient addresses");
      
      // Store all addresses in state
      if (response.data && Array.isArray(response.data)) {
        setPatientAddresses(response.data);
        // Set the first address as selected by default
        if (response.data.length > 0) {
          setSelectedAddress(response.data[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching patient addresses:", error);
    }
  };
  useEffect(() => {
    const fetchpincode = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_POSTALURL}${patientDetails?.pinCode}`,
          {
            headers: {
              // Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data[0].PostOffice[0], "hjbbbnbj");
        // setClinicaddress(response.data[0].PostOffice[0]);
        setPatientaddress(response.data[0].PostOffice[0]);
      } catch (error) {
        console.error("Error fetching slots:", error);
      }
    };
    // const fetchclinicpincode = async () => {
    //   try {
    //     const response = await axios.get(
    //       `${process.env.REACT_APP_POSTALURL}751013`,
    //       {
    //         headers: {
    //           // Authorization: `Bearer ${token}`,
    //         },
    //       }
    //     );
    //     console.log(response.data[0].PostOffice[0], "jbkjbjkbjb");
    //     setClinicaddress(response.data[0].PostOffice[0]);
    //   } catch (error) {
    //     console.error("Error fetching slots:", error);
    //   }
    // };
    // fetchpincode();
    // fetchclinicpincode();
    if (hospitaldata ) {
      setClinicaddress({
        address1: hospitaldata?.address, // or whatever you want
        deliveryCity: hospitaldata.city,
        deliveryState: hospitaldata.state,
        deliveryCountry: hospitaldata.country,
        deliveryPinCode: hospitaldata.pinCode,
      });
    }
  }, [patientDetails]);

  // useEffect(() => {
  //   if (!patientId) return;

  //   const token = localStorage.getItem("auth_token");
  //   const url = `${process.env.REACT_APP_CARTURL}common/cart-list/${patientId}`;

  //   axios
  //     .get(url, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((response) => {
  //       // the API payload is in response.data
  //       console.log("Cart list for patient:", response.data.data.carts);
  //       // store it in state if you like
  //       setCartList(response.data.data.carts || []);
  //     })
  //     .catch((err) => {
  //       console.error(
  //         "Failed to fetch cart list:",
  //         err.response?.data || err.message
  //       );
  //     });
  // }, [patientId]);

  const getLabBillFromCartData = (cartData) => {
    if (!cartData) return 0;

    const items = cartData.labTestItems || [];
    const itemsTotal = items.reduce(
      (sum, item) => sum + (parseFloat(item.amount) || 0),
      0
    );

    const cartAmount = Number(cartData.amount);
    const discountAmount = Number(cartData.discountAmount) || 0;
    const paidAmount = Number(cartData.paidAmount);

    if (!Number.isNaN(cartAmount) && cartAmount > 0) {
      return cartAmount;
    }
    if (itemsTotal > 0) {
      return itemsTotal;
    }
    if (!Number.isNaN(paidAmount) && paidAmount > 0) {
      return paidAmount + discountAmount;
    }
    return 0;
  };

  const syncOrderSummaryFromCart = (cartData) => {
    if (!cartData) return;

    const discountAmount = Number(cartData.discountAmount) || 0;
    const paidAmount = Number(cartData.paidAmount);
    const labBill = getLabBillFromCartData(cartData);

    setLabTestBill(labBill);
    setTotalDiscount(discountAmount);
    if (!Number.isNaN(paidAmount) && paidAmount >= 0) {
      setTotalAmount(paidAmount);
    } else {
      setTotalAmount(Math.max(0, labBill - discountAmount));
    }
  };

  const applyLabCartDataFromResponse = (cartData) => {
    if (!cartData) return;

    setLabCartDetails(cartData);
    if (cartData.cartId) {
      setCartId(cartData.cartId);
    }
    setlabtests(cartData.labTestItems || []);
    syncOrderSummaryFromCart(cartData);

    const couponFromCart =
      cartData.couponCode ||
      cartData.voucherCode ||
      cartData.appliedCouponCode ||
      "";
    if (couponFromCart) {
      setAppliedCoupon(couponFromCart);
      setCouponInput(couponFromCart);
    } else {
      setAppliedCoupon("");
      setCouponInput("");
    }
  };

  const fetchLabCartDetails = async () => {
    const labCart = cartList.find((c) => c.cartType === "LAB");
    if (!labCart?.cartId) return null;

    const token = localStorage.getItem("auth_token");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_CARTURL}lab/details?cartId=${labCart.cartId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data?.data) {
        applyLabCartDataFromResponse(res.data.data);
        return res.data.data;
      }
      return null;
    } catch (err) {
      console.error("Failed to fetch lab-cart details:", err.response || err);
      return null;
    }
  };

  useEffect(() => {
    fetchLabCartDetails();
  }, [cartList]);
  useEffect(() => {
    const fetchCartData = async () => {
      if (!patientDetails.curebayPatientId) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_CARTURL}medicine/details?patientId=${patientDetails.curebayPatientId}`
        );
        const data = await response.json();
        if (data.status === "OK") {
          setCartId(data.data.cartId);
          setMedicines(data.data.medicineItems || []);
          setMedicineDetails(data.data);
          console.log(data.data, "dfghjkvghj");
        }
      } catch (error) {
        console.error("Error fetching cart data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCartData();
  }, [patientDetails.curebayPatientId]);

  const handleRemoveLab = async (labId) => {
    const labCart = cartList.find((c) => c.cartType === "LAB");
    console.log(cartList, "cartListcartListcartList");
    if (!patientDetails.curebayPatientId || !labCart) return;

    // setRemovingItems((prev) => new Set([...prev, medicineId]));

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}lab/removeLab`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cartId: labCart.cartId,
            id: labId,
            patientId: patientDetails.curebayPatientId,
          }),
        }
      );

      if (response.ok) {
        const responseData = await response.json().catch(() => ({}));
        if (responseData?.data) {
          applyLabCartDataFromResponse(responseData.data);
        } else {
          setlabtests((prev) => prev.filter((l) => l.id !== labId));
          await fetchLabCartDetails();
        }
      }
    } catch (error) {
      console.error("Error removing medicine:", error);
    } finally {
      // setRemovingItems((prev) => {
      //   const newSet = new Set(prev);
      //   newSet.delete(medicineId);
      //   return newSet;
      // });
    }
  };

  // const deliveryFee = totalAmount >= 500 ? 0 : 49;
  // const finalAmount = totalAmount;

   useEffect(() => {
    if (!patientId) return;
    const checkConsent = async () => {
      // setLoading(true);
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      try {
        const res = await fetch(
          `${API_URL}patientConsent/by-patient?patientId=${patientId}&serviceType=CUREBAY_SERVICE&Status=1`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
          }
        );
        const data = await res.json();
       
        if (Array.isArray(data.data) && data.data.length > 0) {
        
        } else {
          setConsentGiven(true)
          
        }
      } catch (err) {
      
      }
    };
    checkConsent();
    // eslint-disable-next-line
  }, [selectedPatient]);
  useEffect(() => {
    if (labCartDetails) {
      syncOrderSummaryFromCart(labCartDetails);
      return;
    }

    if (labtests.length === 0) return;

    const labBill = labtests.reduce((acc, item) => {
      const price = parseFloat(item.amount) || 0;
      return acc + price;
    }, 0);

    setLabTestBill(labBill);
    setTotalDiscount(0);
    setTotalAmount(labBill);
  }, [labtests, labCartDetails, medicines]);
  console.log(labtests, "labtests");
  const handleProceed = async () => {
    if (labtests.length > 0) {
      if (!preferDateupdate) {
        toast.error("Please Select Prefferef Date & Time");
        return;
      }
    }
    if (!deliveryaddress) {
      toast.error("Please Select Delivery Address");
      return;
    }
    handleAddressConfirm();
    console.log("xdcfgvhbj")

    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    // const selectedMedicineDetails = medicinesData.filter((med) =>
    //   selectedMedicines.includes(med.id)
    // );

    // const selectedLabDetails = labTestsData.filter((lab) =>
    //   selectedLabs.includes(lab.id)
    // );
    // console.log(selectedMedicineDetails, selectedLabDetails, "fcgvhjiko");
   
    // const hospitalIds = new Set(checkedLabDetails.map((d) => d.labId));
    // if (hospitalIds.size > 1) {
    //   toast.error(
    //     "Select all test from the same lab or replace the tests in your cart"
    //   );
    //   return;
    // }
const addressFields = [
  deliveryaddress.address1,
  deliveryaddress.deliveryCity,
  deliveryaddress.deliveryState,
  deliveryaddress.deliveryCountry,
  deliveryaddress.deliveryPinCode,
];
const fullAddress = addressFields.filter(Boolean).join(', ');
console.log(labtests, "labtests");
const PatientName = `${selectedPatient?.firstName ?? ""} ${selectedPatient?.lastName ?? ""}`.trim();
    const payload = {
      clinicId: clinicId,
      // appointmentObjectId: selectedPatient?.id,
      patientPrescriptionObjectId:  selectedPatient?.prescriptionId || null,
      patientName: PatientName ||selectedPatient?.patientName,
      orderPlacedTo: "SMART_CLINIC",
      patientMobileNo: selectedPatient?.patientMobileNo || patientDetails?.mobileNumber,
      txnId: "",
      appointmentId: selectedPatient?.appointmentId,
      patientId: selectedPatient?.patientId,
      patientLabTestsList: 
  {
    labOrderId: labCartDetails?.patientOrderId ? labCartDetails?.patientOrderId : labCartDetails?.patientLabTestOrderId || "", // e.g. "LAB102715"
    labType: labtests[0]?.labTestType?.toLowerCase() || "",  // e.g. "pathology"
    labTests: labtests.map((item) => ({
      labTestId: item.labTestCode,           // e.g. "CB12600"
      labTestName: item.labTestName,         // e.g. "Lipid Profile"
      status: 1,                             
      amount: item.amount,                   // e.g. 290
      discountedAmount: item.totalAmount ,// default to 0 if null/undefined
      labPartnerName:labCartDetails?.hospitalName
    }))
  },

      // patientLabTestsList: labtests.map((item) => ({
      //   labTestId: item.labTestCode || "",
      //   labTestName: item.labTestName,
      //   status: 1,
      //   amount: item.amount,
      //   discountedAmount: "",
      // })),
     
      appoimentDetails: [],
      amount: 0,
      discountedAmount: 0,
     address: fullAddress || "", 
     enquiryTickets:null,
  ...(prefereeddate && {
    labTestDateAndTime: {
      collectionDate: prefereeddate.date.substring(0, 10),
      collectionTime: prefereeddate.time,
    },
  }),
     
    };
    console.log(payload, "payloadjhgbjkb");

    try {
      const response = await fetch(`${API_URL}orders/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log(result, "result");
      if (result.status === 200) {
        const orderId = result.data?.id;
        setorderid(orderId);
        // toast.success(result.message || "Order submitted successfully");
        setModalOpen(true);

        // After the order is placed, create a D2C ticket (like surgery & ambulance)
        // and link it back to the order.
        try {
          const hospitalId = localStorage.getItem("hospitalid") || "";
          const ticketPayload = {
            patientDetails: {
              patientId: selectedPatient?.patientId || patientId || "",
              medicaseId: "",
              patientName: PatientName || selectedPatient?.patientName || "",
              dob: patientDetails?.dob || "",
              gender: patientDetails?.gender || "",
              mobileNumber: String(
                selectedPatient?.patientMobileNo ||
                  patientDetails?.mobileNumber ||
                  ""
              ),
              email: patientDetails?.email || "",
              escallationNumber: "",
              address: fullAddress || patientDetails?.address || "",
              pincode: String(patientDetails?.pinCode || ""),
            },
            serviceDetailsMessage: "",
            tickeType: "LAB_TEST",
            ticketSource: "HOSPITAL360",
            hospitalId: hospitalId,
          };

          const ticketRes = await fetch(
            `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(ticketPayload),
            }
          );
          const ticketData = await ticketRes.json();

          if (ticketRes.ok && ticketData?.status === 200 && ticketData?.data) {
            const ticketId = ticketData.data.id;
            await fetch(`${API_URL}createenquiry/order?orderId=${orderId}`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
              body: JSON.stringify({
                ticketId: ticketId,
                ticketStatus: "INPROGRESS",
              }),
            });
          }
        } catch (ticketErr) {
          console.error("Failed to create/link D2C ticket:", ticketErr);
        }
      } else {
        toast.error(result.message || "Order submission failed");
      }
    } catch (error) {
      toast.error("Something went wrong while submitting order");
    }
  };
  const handlePay = async () => {
    if (paymentMode === "CASH") {
      // await confirmAppointment("CASH");
    }
  };
 
  const limitTimeForLab = (timeParam) => {
    console.log(timeParam, "sdpfdibdhpisdhpb");
    if (moment(preferDate).isSame(moment().format("YYYY-MM-DD"))) {
      let current_time_in_hour = moment().hour();

      let am_or_pm = timeParam.value.substring(0, 5).split(" ")[1];
      let time_in_hours = Number(timeParam.value.substring(0, 5).split(" ")[0]);
      if (am_or_pm == "PM" && time_in_hours != 12) {
        time_in_hours += 12;
      }
      console.log(
        "current_time_in_hour:",
        current_time_in_hour + 4,
        "time_in_hours: ",
        time_in_hours
      );
      if (current_time_in_hour + 4 > time_in_hours) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  // const handleConfirm = async () => {
  //   try {
  //     // 1) fetch from India Post Pincode API
  //     const pinResp = await axios.get(
  //       `https://api.postalpincode.in/pincode/${pincode}`
  //     );
  //     if (pinResp.data[0].Status !== "Success") {
  //       return toast.error("Invalid pincode");
  //     }
  //     const office = pinResp.data[0].PostOffice[0];
  //     const deliveryCity = office.District;
  //     const deliveryState = office.State;
  //     const deliveryCountry = office.Country;

  //     // 2) get lat/lng via Google Geocoding (you’ll need your API key)
  //     const geo = await axios.get(
  //       "https://maps.googleapis.com/maps/api/geocode/json",
  //       {
  //         params: {
  //           address: pincode,
  //           key: process.env.REACT_APP_GOOGLE_MAPS_KEY,
  //         },
  //       }
  //     );
  //     const loc = geo.data.results[0].geometry.location;

  //     // 3) now build your payload
  //     const payload = {
  //       deliveryMobileNumber: mobile || null,
  //       deliveryAddress1: addr1,
  //       deliveryAddress2: addr2,
  //       deliveryCity,
  //       deliveryState,
  //       deliveryCountry,
  //       deliveryZipcode: pincode,
  //       cartId,
  //       latitude: loc.lat,
  //       longitude: loc.lng,
  //     };
  //     console.log(payload, "xcgfhjbk");

  //     // 4) POST to CureBay
  //     // await axios.post(
  //     //   'https://patient-api-stage.curebay.in/dhp/webhook/updateAddress',
  //     //   payload
  //     // )

  //     // toast.success('Address updated successfully')
  //     // onClose()
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Failed to update address");
  //   }
  // };
  const handlePreferConfirm = async () => {
    try {
      const cartId = labCartDetails?.cartId;
      if (!cartId) throw new Error("No cartId");

      // build preferDateTime: "YYYY-MM-DD HH:mm:ss"
      const [timeStart] = preferTime.split(" - ");
      const md = moment(`${preferDate} ${timeStart}`, "YYYY-MM-DD hh A");
      const token = localStorage.getItem("access_token");
      const payload = {
        modifiedBy: patientDetails.curebayPatientId,
        preferDateTime: md.format("YYYY-MM-DD HH:mm:ss"),
        preferTime,
      };
      console.log(payload, cartId, "jhbhjbjk");
      const res = await fetch(
        `${process.env.REACT_APP_API_URL_PATIENTS}PatientLabTestsOrderDetails/update-preferred-time/${cartId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      setPrefereeddate({
        date: payload.preferDateTime,
        time: payload.preferTime,
      });
      console.log(res, "xdcfvgbhj");
      toast.success("Preferred slot updated!");
      setPreferDateupdate(true);
      setPreferModalOpen(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update preferred time");
    }
  };

//   const handleAddressConfirm = async () => {
//   try {
//     const token = localStorage.getItem("access_token");
//     const cartIds = cartList.map((c) => c.cartId).filter(Boolean);

//     if (cartIds.length === 0) {
//       throw new Error("No carts available to update");
//     }

//     // Prepare common address payload
//     let addressPayloadBase;
//     if (addressOption === "clinic") {
//       addressPayloadBase = {
//         deliveryAddress1: "OCAC Tower",
//         deliveryCity: clinicaddress.Division,
//         deliveryState: clinicaddress.State,
//         deliveryCountry: clinicaddress.Country,
//         deliveryPinCode: clinicaddress.pinCode,
//       };
//     } else if (addressOption === "patient") {
//       addressPayloadBase = {
//         deliveryAddress1: patientDetails.address,
//         deliveryCity: patientDetails.Division,
//         deliveryState: patientaddress.State,
//         deliveryCountry: patientaddress.Country,
//         deliveryPinCode: patientDetails.pinCode,
//       };
//     } else if (addressOption === "add") {
//       addressPayloadBase = {
//         deliveryAddress1: houseNo,
//         deliveryAddress2: address1,
//         deliveryCity: city,
//         deliveryState: stateField,
//         deliveryPinCode: pincode,
//         deliveryCountry: "India",
//       };
//     }

//     // Make parallel API calls
//     await Promise.all(
//       cartIds.map(async (cartId) => {
//         const res = await fetch(
//           `${process.env.REACT_APP_API_URL_PATIENTS}webhook/updateAddress`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ ...addressPayloadBase, cartId }),
//           }
//         );

//         let json = {};
//         try {
//           json = await res.json(); // Try parsing
//         } catch (e) {
//           console.warn(`No JSON returned for cart ${cartId}`);
//         }

//         if (!res.ok) {
//           throw new Error(
//             `Update failed for cart ${cartId}: ${json.message || res.statusText || res.status}`
//           );
//         }

//         // Only update state once, outside loop
//         return json;
//       })
//     );

//     // Update address state once if all updates succeeded
//     setDeliveryaddress({
//       address1: addressPayloadBase.deliveryAddress1,
//       deliveryCity: addressPayloadBase.deliveryCity,
//       deliveryState: addressPayloadBase.deliveryState,
//       deliveryCountry: addressPayloadBase.deliveryCountry,
//       deliveryPinCode: addressPayloadBase.deliveryPinCode,
//     });

//     setAddressupdate(true);
//     setaddressModalOpen(false);
//     // toast.success("Address updated successfully!");
//   } catch (err) {
//     console.error("handleAddressConfirm error:", err);
//     toast.error(err.message || "Failed to update address");
//   }
// };

  const handleAddressConfirm = async () => {
    try {
      const token = localStorage.getItem("auth_token");
      const cartIds = cartList.map((c) => c.cartId).filter(Boolean);
      if (cartIds.length === 0) {
        throw new Error("No carts available to update");
      }
      let addressPayloadBase;
      if (addressOption === "clinic") {
        // 3. Common address payload
        addressPayloadBase = {
          deliveryAddress1: hospitaldata?.address,
          // deliveryAddress2: "Acharya Vihar, Lane 8",
          deliveryCity: hospitaldata.city,
          deliveryState: hospitaldata.State,
          deliveryCountry: "India",
          deliveryPinCode: hospitaldata.pinCode,
          deliveryMobile: patientDetails?.mobileNumber,
          deliveryContactName: `${patientDetails?.firstName ?? ""} ${
            patientDetails?.lastName ?? ""
          }`.trim(),
        };
      } else if (addressOption === "patient") {
        // Validate patient address selection
        if (!selectedAddress) {
          toast.error("Please select a patient address");
          return;
        }

        // 3. Common address payload using selected address
        addressPayloadBase = {
          // deliveryMobileNumber: "9337482639",
          deliveryAddress1: selectedAddress?.address || "",
          deliveryAddress2: selectedAddress?.landmark || "",
          deliveryCity: selectedAddress?.state || "",
          deliveryState: selectedAddress?.state || "",
          deliveryCountry: selectedAddress?.country || "India",
          deliveryPinCode: selectedAddress?.pincode || "",
          deliveryMobile: patientDetails?.mobileNumber,
          deliveryContactName: `${patientDetails?.firstName ?? ""} ${
            patientDetails?.lastName ?? ""
          }`.trim(),
          // latitude: 20.363914,
          // longitude: 85.79742,
        };
      } else if (addressOption === "add") {
        // First, save the new address to addressbook
        try {
          const addressPayload = {
            address: houseNo,
            landmark: address1,
            state: fetchedState || stateField,
            pincode: pincode,
            country: fetchedCountry || "India",
            patientId: patientId,
          };

          const addressResponse = await axios.post(
            `${API_URL}addressbook`,
            addressPayload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: localStorage.getItem("tenantId"),
              },
            }
          );

          console.log("Address saved successfully:", addressResponse.data);
          
          // Update the patient addresses list with the new address
          if (addressResponse.data && addressResponse.data.id) {
            const newAddress = {
              id: addressResponse.data.id,
              address: houseNo,
              landmark: address1,
              state: fetchedState || stateField,
              pincode: pincode,
              country: fetchedCountry || "India",
              patientId: patientId,
            };
            
            // Add new address to the list and select it
            setPatientAddresses(prev => [...prev, newAddress]);
            setSelectedAddress(newAddress);
            
            // Reset form fields after successful submission
            resetAddressForm();
            
            toast.success("Address added successfully!");
          }
        } catch (addressError) {
          console.error("Failed to save address:", addressError);
          toast.error("Failed to save address. Please try again.");
          return; // Stop execution if address saving fails
        }

        // 3. Common address payload for delivery
        addressPayloadBase = {
          deliveryAddress1: houseNo,
          deliveryAddress2: address1,
          // deliveryLandmark: landmark,
          deliveryCity: city,
          deliveryState: fetchedState || stateField,
          deliveryPinCode: pincode,
          deliveryCountry: fetchedCountry || "India",
           deliveryMobile:patientDetails?.mobileNumber,
           deliveryContactName: `${patientDetails?.firstName ?? ''} ${patientDetails?.lastName ?? ''}`.trim()
        };
      }
 const payload = {
      ...addressPayloadBase,
      cartIds, // sending array of cart IDs
    };
    try {
      const token = localStorage.getItem("auth_token");
 const labCartId = cartList.find(cart => cart.cartType === "LAB")?.cartId || null;
  const payload = {
    ...addressPayloadBase,
    CartId:labCartId, // sending array of cart IDs
  };
console.log(cartList,"cartList")
  const res = await fetch(
    `${process.env.REACT_APP_API_URL_PATIENTS}webhook/updateAddress`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // optional, if your API requires auth
      },
      body: JSON.stringify(payload),
    }
  );
// console.log(res.status,"edrtfyguhij")
//   if (res.status !== 200) {
//     throw new Error("Failed to update  jghvh address");
 // }

 // const responseData = await res.json(); // optional: parse if you need response

  setDeliveryaddress({
    address1: addressPayloadBase.deliveryAddress1,
    deliveryCity: addressPayloadBase.deliveryCity,
    deliveryState: addressPayloadBase.deliveryState,
    deliveryCountry: "India",
    deliveryPinCode: addressPayloadBase.deliveryPinCode,
  });
} catch (error) {
  console.error("Address update failed:", error);
  toast.error("Failed to update address");
}
   
      setAddressupdate(true);
      setaddressModalOpen(false);
    } catch (err) {
      console.error("handleAddressConfirm error:", err);
      toast.error(err.message || "Failed to update address");
    }
  };
  console.log(medicines, "cartListcartList");

  const getLabCartId = () =>
    labCartDetails?.cartId ||
    cartList.find((c) => c.cartType === "LAB")?.cartId;

  const handleCopyCouponCode = (code) => {
    navigator.clipboard.writeText(code);
    toast.success("Coupon code copied");
  };

  const handleApplyCoupon = async (code) => {
    const value = (code || couponInput).trim();
    const labCartId = getLabCartId();
    if (!value) {
      toast.error("Please enter a coupon code");
      return;
    }
    if (!labCartId) {
      toast.error("Cart not ready. Please try again.");
      return;
    }
    if (applyingCoupon) return;

    setApplyingCoupon(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}benefits/apply-benefits`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cartId: labCartId,
            cartType: "LAB",
            serviceType: "VOUCHER",
            couponCode: value,
            isCureCoinApplied: "N",
          }),
        }
      );

      const data = await response.json().catch(() => ({}));

      if (response.ok && data?.data) {
        applyLabCartDataFromResponse(data.data);
        setCouponModalOpen(false);
        toast.success(data.message || "Coupon applied successfully");
      } else if (response.ok) {
        setAppliedCoupon(value);
        setCouponInput(value);
        setCouponModalOpen(false);
        toast.success("Coupon applied successfully");
        await fetchLabCartDetails();
      } else {
        toast.error(data?.message || data?.error || "Failed to apply coupon");
      }
    } catch (error) {
      console.error("Error applying coupon:", error);
      toast.error("Failed to apply coupon");
    } finally {
      setApplyingCoupon(false);
    }
  };

  const handleRemoveCoupon = async (e) => {
    e?.stopPropagation?.();
    const labCartId = getLabCartId();
    if (!labCartId || !appliedCoupon || removingCoupon) return;

    setRemovingCoupon(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}benefits/remove-benefits`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cartId: labCartId,
            cartType: "LAB",
            serviceType: "VOUCHER",
            couponCode: appliedCoupon,
            isCureCoinApplied: "N",
          }),
        }
      );

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        setAppliedCoupon("");
        setCouponInput("");
        toast.success("Coupon removed successfully");
        if (data?.data) {
          applyLabCartDataFromResponse(data.data);
        } else {
          await fetchLabCartDetails();
        }
      } else {
        toast.error(data?.message || data?.error || "Failed to remove coupon");
      }
    } catch (error) {
      console.error("Error removing coupon:", error);
      toast.error("Failed to remove coupon");
    } finally {
      setRemovingCoupon(false);
    }
  };

  const patientFullName =
    selectedPatient?.patientName ||
    `${patientDetails?.firstName || ""} ${patientDetails?.lastName || ""}`.trim();
  const patientInitials = patientFullName
    ? patientFullName
        .split(" ")
        .filter(Boolean)
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : "—";
  const formattedAddress = [
    deliveryaddress.address1,
    deliveryaddress.deliveryCity,
    deliveryaddress.deliveryState,
    deliveryaddress.deliveryPinCode,
  ]
    .filter(Boolean)
    .join(", ");
  const appointmentDateLabel = selectedPatient?.whenAppointment
    ? moment(selectedPatient.whenAppointment).format("DD MMM YYYY")
    : "";
  const preferredSlotLabel =
    prefereeddate?.date && prefereeddate?.time
      ? `${prefereeddate.date.substring(0, 10)} at ${prefereeddate.time}`
      : "";

  if (!patientDetails.curebayPatientId) {
    return (
      <OurLayouts>
        <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-4">
          <div className="relative bg-white rounded-2xl shadow-xl p-8 text-center max-w-md border border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-r from-[#004172] to-[#3cba84] rounded-full flex items-center justify-center mx-auto mb-4">
              <ShoppingCart className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">
              No Patient Selected
            </h2>
            <p className="text-gray-600 mb-6">
              Please select a patient to view cart.
            </p>
            <button
              onClick={() => navigate("/BookService")}
              className="w-full bg-[#0D6B6E] text-white py-3 px-6 rounded-xl font-semibold hover:bg-[#0a5a5d] transition-colors"
            >
              Go Back
            </button>
          </div>
        </div>
      </OurLayouts>
    );
  }

  if (loading) {
    return (
      <OurLayouts>
        <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center">
          <div className="text-center">
            <div className="relative">
              <div className="w-16 h-16 border-4 border-gray-200 rounded-full animate-spin"></div>
              <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-t-[#004172] rounded-full animate-spin"></div>
            </div>
            <p className="text-gray-600 mt-4 font-medium">
              Loading your cart...
            </p>
          </div>
        </div>
      </OurLayouts>
    );
  }
console.log(labtests,labCartDetails?.hospitalName,"erdtfyguhijok")
  return (
    <OurLayouts>
      <div className="min-h-screen bg-[#F8F9FA]">
        <div className="relative z-10 p-4 md:p-6 max-w-7xl mx-auto">
          <div className="mx-auto">
            {labtests.length === 0 ? (
              <div className="p-12 text-center">
                <div className="w-20 h-20 bg-[#0D6B6E] rounded-full flex items-center justify-center mx-auto mb-6">
                  <ShoppingCart className="w-10 h-10 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">
                  Your cart is empty
                </h2>
              </div>
            ) : (
              <>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 rounded-full bg-[#0D6B6E] flex items-center justify-center shadow-sm">
                    <ShoppingCart className="w-4 h-4 text-white" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900 mb-0">
                    Cart Items
                  </h2>
                  <span className="min-w-[24px] h-6 px-1.5 rounded-full bg-[#0D6B6E] text-white text-xs font-semibold flex items-center justify-center">
                    {labtests.length}
                  </span>
                </div>

                <div
                  className="rounded-xl p-4 mb-5 flex flex-wrap items-center justify-between gap-4 overflow-hidden"
                  style={{ ...CART_CARD_STYLE, background: PATIENT_STRIP_GRADIENT }}
                >
                  <div className="flex items-center gap-3 min-w-0">
                    <span className="w-11 h-11 rounded-full bg-[#0D6B6E] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                      {patientInitials}
                    </span>
                    <div className="min-w-0">
                      <p className="font-bold text-gray-900 mb-0 text-sm truncate">
                        {patientFullName || "—"}
                      </p>
                      <p className="text-xs text-[#64748B] mb-0">
                        {[
                          patientDetails?.age ? `Age: ${patientDetails.age}` : null,
                          patientDetails?.gender,
                          selectedPatient?.patientMobileNo ||
                            patientDetails?.mobileNumber,
                        ]
                          .filter(Boolean)
                          .join(" / ")}
                      </p>
                    </div>
                  </div>
                  {selectedPatient?.appointmentId && (
                    <p className="text-sm text-[#64748B] mb-0 whitespace-nowrap">
                      Appt #{selectedPatient.appointmentId}
                      {appointmentDateLabel ? `, ${appointmentDateLabel}` : ""}
                    </p>
                  )}
                </div>

                <div className="grid lg:grid-cols-3 gap-5">
                  <div className="lg:col-span-2">
                    {labtests?.length > 0 && (
                      <div className="bg-white overflow-hidden" style={CART_CARD_STYLE}>
                        <div
                          className="px-5 flex items-center justify-between"
                          style={{
                            background: CART_SECTION_HEADER_GRADIENT,
                            minHeight: 52,
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                              <Eye className="w-4 h-4 text-[#0D6B6E]" />
                            </span>
                            <h3 className="font-bold text-gray-900 mb-0 text-[15px]">
                              Lab Test Details
                            </h3>
                          </div>
                          <span className="text-sm text-gray-500 font-medium">
                            {labtests.length} items
                          </span>
                        </div>

                        <div className="divide-y divide-gray-100">
                          {labtests.map((lab, index) => {
                            const originalTotal = parseFloat(lab.amount) || 0;
                            const itemTotal =
                              lab.totalAmount != null
                                ? parseFloat(lab.totalAmount)
                                : originalTotal;
                            const discountAmount =
                              parseFloat(lab.discountAmount) || 0;
                            const hasDiscount =
                              discountAmount > 0 ||
                              itemTotal < originalTotal - 0.009;
                            const discountPercent =
                              hasDiscount && originalTotal > 0
                                ? Math.round(
                                    ((discountAmount ||
                                      originalTotal - itemTotal) /
                                      originalTotal) *
                                      100
                                  )
                                : 0;

                            return (
                            <div
                              key={lab.id}
                              className="px-5 py-4 hover:bg-gray-50/50 transition-colors"
                              style={{ animationDelay: `${index * 100}ms` }}
                            >
                              <div className="flex items-center gap-4">
                                <div className="w-14 h-14 bg-[#F1F4F9] rounded-xl flex items-center justify-center flex-shrink-0">
                                  <img
                                    src={Labimg}
                                    alt={lab.labTestName}
                                    className="w-8 h-8 object-contain"
                                  />
                                </div>

                                <div className="flex-1 min-w-0">
                                  <h3 className="text-sm font-bold text-[#0D6B6E] mb-0.5">
                                    {lab.labTestName}
                                  </h3>
                                  <p className="text-xs text-[#64748B] mb-0.5">
                                    {labCartDetails?.hospitalName}
                                  </p>
                                  <p className="text-xs text-[#64748B] mb-0">
                                    MRP ₹
                                    {(parseFloat(lab.amount) || 0).toFixed(2)}
                                  </p>
                                </div>

                                <button
                                  type="button"
                                  onClick={() => handleRemoveLab(lab.id)}
                                  disabled={removingItems.has(lab.id)}
                                  className="p-1.5 text-red-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50 flex-shrink-0"
                                >
                                  {removingItems.has(lab.id) ? (
                                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-red-400 border-t-transparent" />
                                  ) : (
                                    <Trash2 className="w-4 h-4" />
                                  )}
                                </button>

                                <div className="flex flex-col items-end gap-1 min-w-[120px] flex-shrink-0">
                                  {hasDiscount ? (
                                    <div className="flex items-center gap-2 flex-wrap justify-end">
                                      <span className="font-bold text-green-600 text-base leading-none">
                                        ₹{itemTotal.toFixed(2)}
                                      </span>
                                      <span className="text-sm text-gray-400 line-through leading-none">
                                        ₹{originalTotal.toFixed(2)}
                                      </span>
                                      {/* {discountPercent > 0 && (
                                        <span className="text-[11px] font-bold text-red-500 bg-pink-50 px-1.5 py-0.5 rounded leading-none">
                                          {discountPercent}% OFF
                                        </span>
                                      )} */}
                                    </div>
                                  ) : (
                                    <span className="font-bold text-[#0D6B6E] text-sm">
                                      ₹{itemTotal.toFixed(2)}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                          })}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="lg:col-span-1 space-y-4">
                    {appliedCoupon ? (
                      <div
                        className="w-full flex items-center justify-between gap-3 px-4 py-3.5 rounded-xl"
                        style={{ background: "#5FAA8E" }}
                      >
                        <div className="flex items-center gap-3 min-w-0">
                          <span className="w-9 h-9 flex-shrink-0 rounded-lg bg-[#004172] flex items-center justify-center text-white">
                            <Percent className="w-4 h-4" strokeWidth={2.5} />
                          </span>
                          <span className="font-bold text-white text-[15px] truncate">
                            Avail Coupons
                          </span>
                        </div>
                        <button
                          type="button"
                          onClick={handleRemoveCoupon}
                          disabled={removingCoupon}
                          className="flex-shrink-0 px-4 py-1.5 text-xs font-bold text-white border-2 border-white rounded-lg bg-transparent hover:bg-white/10 transition-colors disabled:opacity-60"
                        >
                          {removingCoupon ? "REMOVING..." : "REMOVE"}
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={() => setCouponModalOpen(true)}
                        className="w-full flex items-center justify-between gap-3 px-4 py-3.5 rounded-xl border transition-colors hover:opacity-95"
                        style={{
                          background: "#EEF6FB",
                          borderColor: "#B8D4E8",
                        }}
                      >
                        <div className="flex items-center gap-3 min-w-0">
                          <span
                            className="w-9 h-9 flex-shrink-0 rounded-lg flex items-center justify-center text-white"
                            style={{ background: "#004172" }}
                          >
                            <Percent className="w-4 h-4" strokeWidth={2.5} />
                          </span>
                          <span className="font-bold text-[#004172] text-[15px] truncate">
                            Avail Coupons
                          </span>
                        </div>
                        <span className="flex-shrink-0 px-4 py-1.5 text-xs font-bold text-[#004172] border-2 border-[#004172] rounded-lg bg-white">
                          APPLY
                        </span>
                      </button>
                    )}

                    <div className="bg-white overflow-hidden" style={CART_CARD_STYLE}>
                      <div
                        className="px-5 flex items-center"
                        style={{
                          background: CART_SECTION_HEADER_GRADIENT,
                          minHeight: 52,
                        }}
                      >
                        <h3 className="font-bold mb-0 text-[15px]">
                          <span className="text-[#004172]">Billing </span>
                          <span className="text-[#3cba84]">Details</span>
                        </h3>
                      </div>

                      <div className="px-5 py-4 space-y-3">
                        {labtests?.length > 0 && (
                          <div className="flex justify-between text-sm text-gray-600">
                            <span>Lab Test Bill</span>
                            <span className="font-semibold text-gray-900">
                              ₹ {labTestBill.toFixed(2)}
                            </span>
                          </div>
                        )}

                        <div className="flex justify-between text-sm text-gray-600">
                          <span className={totalDiscount > 0 ? "text-green-600" : ""}>
                            Total Discount
                          </span>
                          <span
                            className={`font-semibold ${
                              totalDiscount > 0
                                ? "text-green-600"
                                : "text-gray-900"
                            }`}
                          >
                            {totalDiscount > 0
                              ? `- ₹ ${totalDiscount.toFixed(2)}`
                              : `₹ ${totalDiscount.toFixed(2)}`}
                          </span>
                        </div>

                        <div className="border-t border-gray-200 pt-3">
                          <div className="flex justify-between items-center">
                            <span className="font-bold text-[#004172]">
                              Payable Amount
                            </span>
                            <span className="font-bold text-[#004172] text-lg">
                              ₹ {totalAmount.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="px-5 pb-5">
                        <button
                          type="button"
                          onClick={() => {
                            if (consentGiven) {
                              setConsentModalOpen(true);
                            } else {
                              handleProceed();
                            }
                          }}
                          className="w-full bg-[#0D6B6E] text-white py-3 px-6 rounded-xl font-semibold flex items-center justify-center gap-2 hover:bg-[#0A9E8A] transition-colors shadow-sm"
                        >
                          <CreditCard className="w-5 h-5" />
                          Proceed to Payment
                        </button>
                      </div>
                    </div>

                    <div className="bg-white overflow-hidden" style={CART_CARD_STYLE}>
                      <div
                        className="px-5 flex items-center gap-2"
                        style={{
                          background: CART_SECTION_HEADER_GRADIENT,
                          minHeight: 52,
                        }}
                      >
                        <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                          <MapPin className="w-4 h-4 text-[#0D6B6E]" />
                        </span>
                        <h3 className="font-bold text-gray-900 mb-0 text-[15px]">
                          Address Details:
                        </h3>
                      </div>
                      <div className="p-5 space-y-4">
                        <div>
                         
                          <p className="text-sm text-gray-700 leading-relaxed mb-3">
                            {formattedAddress || "—"}
                          </p>
                          <button
                            type="button"
                            onClick={() => setaddressModalOpen(true)}
                            className="inline-flex items-center gap-2 px-3 py-1.5 text-[13px] font-semibold text-[#0D6B6E] border border-[#0D6B6E] rounded-md bg-white hover:bg-teal-50 transition-colors"
                          >
                            <Pencil className="w-3.5 h-3.5" />
                            Change Address
                          </button>
                        </div>

                        {labtests?.length > 0 && (
                          <div className="pt-4 border-t border-gray-100">
                            <div className="flex items-start gap-2 mb-2">
                              <Calendar className="w-4 h-4 text-[#0D6B6E] mt-0.5 flex-shrink-0" />
                              <p className="text-sm text-gray-700 mb-0 leading-relaxed">
                                Select your preferred Date and Time for sample
                                collection
                                {preferredSlotLabel ? (
                                  <>
                                    {": "}
                                    <span className="font-semibold text-[#0D6B6E]">
                                      {preferredSlotLabel}
                                    </span>
                                  </>
                                ) : null}
                              </p>
                            </div>
                            <button
                              type="button"
                              onClick={() => setPreferModalOpen(true)}
                              className="inline-flex items-center gap-2 px-3 py-1.5 text-[13px] font-semibold text-[#0D6B6E] border border-[#0D6B6E] rounded-md bg-white hover:bg-teal-50 transition-colors"
                            >
                              <Calendar className="w-3.5 h-3.5" />
                              Select
                            </button>
                          </div>
                        )}
                      </div>
                    </div>

                    <div
                      className="rounded-xl px-4 py-3 flex items-center justify-center gap-2 text-xs text-gray-600"
                      style={{ ...CART_CARD_STYLE, background: "#F9FAFB" }}
                    >
                      <Shield className="w-3.5 h-3.5 text-[#0A9E8A] flex-shrink-0" />
                      Secure checkout — all payments encrypted
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {couponModalOpen && (
            <div
              className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
              onClick={() => setCouponModalOpen(false)}
            >
              <div
                className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="px-5 py-4 flex items-center justify-between border-b border-gray-100">
                  <h3 className="text-lg font-bold text-gray-900 mb-0">
                    Select Coupon
                  </h3>
                  <button
                    type="button"
                    onClick={() => setCouponModalOpen(false)}
                    className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-800 hover:bg-gray-100 rounded-full transition-colors"
                    aria-label="Close"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>

                <div className="px-5 py-5">
                  <div className="relative mb-5">
                    <input
                      type="text"
                      value={couponInput}
                      onChange={(e) => setCouponInput(e.target.value)}
                      placeholder="Select Coupon Code or Enter Corporate Email Ad..."
                      className="w-full pr-20 pl-4 py-3 text-sm border border-gray-900 rounded-xl outline-none focus:ring-2 focus:ring-[#3cba84]/30"
                    />
                    <button
                      type="button"
                      onClick={() => handleApplyCoupon()}
                      disabled={applyingCoupon}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-semibold text-[#3cba84] hover:text-[#2da06d] disabled:opacity-50"
                    >
                      {applyingCoupon ? "Applying..." : "Apply"}
                    </button>
                  </div>

                  <div
                    className="rounded-xl p-4 space-y-4"
                    style={{ background: "#EEF6FB" }}
                  >
                    {AVAILABLE_LAB_COUPONS.map((coupon) => (
                      <div key={coupon.code}>
                        <div className="flex items-center justify-between gap-2 mb-3">
                          <span className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-semibold text-gray-900 border border-gray-900 rounded-md bg-white">
                            {coupon.code}
                            <button
                              type="button"
                              onClick={() => handleCopyCouponCode(coupon.code)}
                              className="text-gray-600 hover:text-[#004172] transition-colors"
                              aria-label={`Copy ${coupon.code}`}
                            >
                              <Copy className="w-4 h-4" />
                            </button>
                          </span>
                          <button
                            type="button"
                            onClick={() => handleApplyCoupon(coupon.code)}
                            disabled={applyingCoupon}
                            className="text-sm font-semibold text-[#3cba84] hover:text-[#2da06d] disabled:opacity-50"
                          >
                            {applyingCoupon ? "Applying..." : "Apply"}
                          </button>
                        </div>
                        <p className="text-sm text-gray-800 mb-0">
                          {coupon.description}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {preferModalOpen && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden">
                <div className="bg-gradient-to-r from-[#004172] to-[#3cba84] text-white px-5 py-4 flex items-start justify-between gap-4">
                  <div className="flex items-start gap-3 min-w-0">
                    <span className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <Calendar className="w-5 h-5 text-white" />
                    </span>
                    <div className="min-w-0">
                      <h3 className="text-lg font-bold mb-0.5">
                        Preferred Date & Time
                      </h3>
                      <p className="text-white/90 text-sm mb-0">
                        Select your preferred slot for sample collection
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setPreferModalOpen(false)}
                    className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 flex-shrink-0 transition-colors"
                    aria-label="Close"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
                <div className="px-5 py-5">
                  <PreferedDateAndTime
                    preferDate={preferDate}
                    preferTime={preferTime}
                    changeDate={changeDate}
                    labStartTime={labCartDetails?.labStartTime}
                    labEndTime={labCartDetails?.labEndTime}
                    labType={labCartDetails?.labTestItems[0]?.labTestType}
                    handleChange={handleChange}
                    limitTimeForLab={limitTimeForLab}
                  />

                  <div className="mt-6 flex justify-end gap-3 pt-2">
                    <button
                      type="button"
                      onClick={() => setPreferModalOpen(false)}
                      className="px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handlePreferConfirm}
                      className="px-5 py-2.5 rounded-lg bg-[#0D6B6E] text-white text-sm font-semibold hover:bg-[#0a5a5d] transition-colors inline-flex items-center gap-2"
                    >
                      <Check className="w-4 h-4" />
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {addressModalOpen && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden">
                <div className="bg-gradient-to-r from-[#004172] to-[#3cba84] text-white px-5 py-4 flex items-start justify-between gap-4">
                  <div className="flex items-start gap-3 min-w-0">
                    <span className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <MapPin className="w-5 h-5 text-white" />
                    </span>
                    <div className="min-w-0">
                      <h3 className="text-lg font-bold mb-0.5">
                        Select Delivery Address
                      </h3>
                      <p className="text-white/90 text-sm mb-0">
                        Choose sample collection address for{" "}
                        {patientFullName || "Patient"}
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setaddressModalOpen(false)}
                    className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 flex-shrink-0 transition-colors"
                    aria-label="Close"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>

                <div className="px-5 py-5">
                  <div className="flex gap-2 mb-5">
                    <button
                      type="button"
                      onClick={() => setAddressOption("clinic")}
                      className={`flex-1 py-2.5 px-3 rounded-lg text-sm font-semibold transition-colors ${
                        addressOption === "clinic"
                          ? "bg-[#0D6B6E] text-white shadow-sm"
                          : "bg-white text-[#0D6B6E] border border-gray-200 hover:bg-gray-50"
                      }`}
                    >
                      Organization Address
                    </button>
                    <button
                      type="button"
                      onClick={() => setAddressOption("patient")}
                      className={`flex-1 py-2.5 px-3 rounded-lg text-sm font-semibold transition-colors ${
                        addressOption === "patient"
                          ? "bg-[#0D6B6E] text-white shadow-sm"
                          : "bg-white text-[#0D6B6E] border border-gray-200 hover:bg-gray-50"
                      }`}
                    >
                      Patient Address
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setAddressOption("add");
                        resetAddressForm();
                      }}
                      className={`flex-1 py-2.5 px-3 rounded-lg text-sm font-semibold transition-colors ${
                        addressOption === "add"
                          ? "bg-[#0D6B6E] text-white shadow-sm"
                          : "bg-white text-[#0D6B6E] border border-gray-200 hover:bg-gray-50"
                      }`}
                    >
                      Add New Address
                    </button>
                  </div>

                  {addressOption === "add" ? (
                    <form className="space-y-4">
                      <input
                        type="text"
                        placeholder="House no | Apartment name *"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D6B6E]/30 focus:border-[#0D6B6E]"
                        value={houseNo}
                        onChange={(e) => setHouseNo(e.target.value)}
                      />
                      <input
                        type="text"
                        placeholder="Address *"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D6B6E]/30 focus:border-[#0D6B6E]"
                        value={address1}
                        onChange={(e) => setAddress1(e.target.value)}
                      />
                      <div className="flex gap-3">
                        <input
                          type="text"
                          placeholder="Pincode *"
                          className="flex-1 border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D6B6E]/30 focus:border-[#0D6B6E]"
                          value={pincode}
                          maxLength={6}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setPincode(value);
                            if (value.length === 6) {
                              fetchAddressByPincode(value);
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <select
                          className="flex-1 border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D6B6E]/30 focus:border-[#0D6B6E]"
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        >
                          <option value="">Select Area</option>
                          {areaOptions.map((area) => (
                            <option key={area.key} value={area.value}>
                              {area.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <input
                        type="text"
                        placeholder="State *"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm bg-gray-50"
                        value={fetchedState}
                        readOnly
                      />
                      <input
                        type="text"
                        placeholder="Country *"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm bg-gray-50"
                        value={fetchedCountry}
                        readOnly
                      />
                    </form>
                  ) : addressOption === "clinic" ? (
                    <div className="rounded-xl border border-[#B8DFDC] bg-[#EEF6F5] p-4">
                      <p className="text-xs font-bold tracking-wide text-[#0D6B6E] mb-1">
                      Organization Address
                      </p>
                      <p className="text-sm text-gray-700 mb-0 leading-relaxed">
                        {[
                          hospitaldata?.address,
                          hospitaldata?.pinCode,
                          hospitaldata?.city || clinicaddress?.city,
                          hospitaldata?.state,
                          hospitaldata?.country,
                        ]
                          .filter((part) => part != null && String(part).trim() !== "")
                          .join(", ") || "—"}
                      </p>
                    </div>
                  ) : (
                    <div>
                      {patientAddresses.length > 0 ? (
                        <div className="max-h-72 overflow-y-auto space-y-3 pr-1">
                          {patientAddresses.map((address, index) => {
                            const isSelected =
                              selectedAddress?.id === address.id;
                            const addressLabel =
                              index === 0 ? "HOME" : "OTHER";

                            return (
                              <div
                                key={address.id}
                                role="button"
                                tabIndex={0}
                                className={`rounded-xl border p-4 cursor-pointer transition-colors ${
                                  isSelected
                                    ? "bg-[#EEF6F5] border-[#B8DFDC]"
                                    : "bg-white border-gray-200 hover:bg-gray-50"
                                }`}
                                onClick={() => setSelectedAddress(address)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    setSelectedAddress(address);
                                  }
                                }}
                              >
                                <div className="flex items-start gap-3">
                                  <div
                                    className={`mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                                      isSelected
                                        ? "border-[#0D6B6E]"
                                        : "border-gray-300"
                                    }`}
                                  >
                                    {isSelected && (
                                      <div className="w-2.5 h-2.5 rounded-full bg-[#0D6B6E]" />
                                    )}
                                  </div>
                                  <input
                                    type="radio"
                                    name="address"
                                    value={address.id}
                                    checked={isSelected}
                                    onChange={() =>
                                      setSelectedAddress(address)
                                    }
                                    className="sr-only"
                                  />
                                  <div className="flex-1 min-w-0">
                                    <p
                                      className={`text-xs font-bold tracking-wide mb-1 ${
                                        isSelected
                                          ? "text-[#0D6B6E]"
                                          : "text-gray-500"
                                      }`}
                                    >
                                      {addressLabel}
                                    </p>
                                    <p className="text-sm text-gray-700 mb-0 leading-relaxed">
                                      {address.address}, {address.landmark},{" "}
                                      {address.state} - {address.pincode}
                                    </p>
                                  </div>
                                  <button
                                    type="button"
                                    className="inline-flex items-center gap-1 text-sm font-medium text-[#0D6B6E] hover:text-[#0a5a5d] flex-shrink-0"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setAddressToEdit(address);
                                      setEditHouseNo(address.address || "");
                                      setEditAddress1(address.landmark || "");
                                      setEditPincode(address.pincode || "");
                                      setEditFetchedState(
                                        address.state || ""
                                      );
                                      setEditFetchedCountry(
                                        address.country || "India"
                                      );
                                      setEditErrors({});
                                      setEditAddressModalOpen(true);
                                    }}
                                  >
                                    <Pencil className="w-3.5 h-3.5" />
                                    Edit
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <p className="text-sm text-gray-500 text-center py-8 mb-0">
                          No addresses found for this patient
                        </p>
                      )}
                    </div>
                  )}

                  <div className="mt-6 flex justify-end gap-3 pt-2">
                    <button
                      type="button"
                      onClick={() => setaddressModalOpen(false)}
                      className="px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleAddressConfirm}
                      className="px-5 py-2.5 rounded-lg bg-[#0D6B6E] text-white text-sm font-semibold hover:bg-[#0a5a5d] transition-colors inline-flex items-center gap-2"
                    >
                      <Check className="w-4 h-4" />
                      Confirm Address
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <PaymentModeModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          onPay={handlePay}
          setPaymentMode={setPaymentMode}
          isLoggingIn={isLoggingIn}
          paymentMode={paymentMode}
          paymentItem={orderid}
          paymenttype="Order"
          venderid={`LAB_${labCartDetails?.patientLabTestOrderId},MED_${medicineDetails?.patientOrderId}`}
        />

        <ConsentModal
          visible={consentModalOpen}
          onClose={() => setConsentModalOpen(false)}
          patientId={patientId}
          mobileNumber={
            selectedPatient?.patientMobileNo || patientDetails.mobileNumber
          }
          serviceType="CUREBAY_SERVICE"
          onConsentComplete={() => {
            setConsentGiven(true);
            setConsentModalOpen(false);
            handleProceed();
          }}
        />
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.6s ease-out;
        }

        .animate-slideInUp {
          animation: slideInUp 0.6s ease-out both;
        }
      `}</style>

      {/* Edit Address Modal */}
      {editAddressModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">Edit Address</h2>
              <button
                onClick={() => {
                  setEditAddressModalOpen(false);
                  setAddressToEdit(null);
                }}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6">
              <div className="space-y-6">
                {/* House no | Apartment name */}
                <div>
                  <input
                    type="text"
                    placeholder="House no | Apartment name *"
                    className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                      editErrors.houseNo 
                        ? 'border-red-500 focus:ring-red-500' 
                        : 'border-gray-300 focus:ring-blue-500'
                    }`}
                    value={editHouseNo}
                    onChange={(e) => setEditHouseNo(e.target.value)}
                    required
                  />
                  {editErrors.houseNo && (
                    <p className="text-red-500 text-sm mt-1">{editErrors.houseNo}</p>
                  )}
                </div>

                {/* Landmark */}
                <div>
                  <input
                    type="text"
                    placeholder="Landmark *"
                    className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                      editErrors.address1 
                        ? 'border-red-500 focus:ring-red-500' 
                        : 'border-gray-300 focus:ring-blue-500'
                    }`}
                    value={editAddress1}
                    onChange={(e) => setEditAddress1(e.target.value)}
                    required
                  />
                  {editErrors.address1 && (
                    <p className="text-red-500 text-sm mt-1">{editErrors.address1}</p>
                  )}
                </div>

                {/* Pincode and State */}
                <div className="flex space-x-4">
                  <div className="flex-1">
                    <input
                      type="text"
                      placeholder="Pincode *"
                      className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                        editErrors.pincode 
                          ? 'border-red-500 focus:ring-red-500' 
                          : 'border-gray-300 focus:ring-blue-500'
                      }`}
                      value={editPincode}
                      maxLength={6}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ''); // Only allow numbers
                        setEditPincode(value);
                        
                        // Clear error when user starts typing
                        if (editErrors.pincode) {
                          setEditErrors(prev => ({ ...prev, pincode: '' }));
                        }
                        
                        // Trigger API call when pincode is 6 digits
                        if (value.length === 6) {
                          console.log("Edit Pincode is 6 digits, calling API for:", value);
                          fetchEditAddressByPincode(value);
                        }
                      }}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      required
                    />
                    {editErrors.pincode && (
                      <p className="text-red-500 text-sm mt-1">{editErrors.pincode}</p>
                    )}
                  </div>
                  <div className="flex-1">
                    <input
                      type="text"
                      placeholder="State *"
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                      value={editFetchedState}
                      readOnly
                    />
                  </div>
                </div>

                {/* Country */}
                <div>
                  <input
                    type="text"
                    placeholder="Country *"
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                    value={editFetchedCountry}
                    readOnly
                  />
                </div>

                {/* Buttons */}
                <div className="flex justify-center space-x-4 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => {
                      setEditAddressModalOpen(false);
                      setAddressToEdit(null);
                    }}
                    className="py-3 px-8 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-300 bg-gray-500 text-white hover:bg-gray-600 hover:shadow-lg"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleEditAddressSubmit}
                    className="py-3 px-8 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-300 bg-gradient-to-r from-[#004172] to-[#3cba84] text-white hover:shadow-lg hover:scale-105"
                  >
                    Update Address
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </OurLayouts>
  );
}
